const stub = '.article__bg-stub';
const largeCard = `.article_wide ${stub}`;

const generateCanvas = isSmall => {
    const text = 'MONETNIK.RU';
    const canvas = document.createElement('canvas');
    const fontSize = isSmall ? 15 : 24;
    const height = fontSize * 4.5;

    canvas.setAttribute('height', `${height}`);
    canvas.setAttribute('width', `${fontSize * 9}`);
    const ctx = canvas.getContext('2d');
    ctx.rotate((-Math.PI / 180) * 25);
    ctx.fillStyle = '#293172';
    ctx.font = `${fontSize}px sans-serif`;
    ctx.fillText(text, isSmall ? -10 : 0, height);

    return canvas.toDataURL('image/png');
};

const setBackgroundFromCanvas = ($elements, imageUrl) => {
    if (!$elements.length) return;

    $elements.forEach($el => {
        $el.style.backgroundImage = `url(${imageUrl})`;
    });
};

export default function LogoGenerator(context) {
    const $largeCards = context.querySelectorAll(largeCard);

    if (MNTK.deviceType !== 'm') {
        setBackgroundFromCanvas($largeCards, generateCanvas(false));
    }
}
